import { printHtmlNodesToText, printHtmlNodesToJsx, generateJsxKey } from '@utils/ast';
import { PM2OpgavekompleksetComponent } from './comp.root.js';
import { jsx } from 'react/jsx-runtime';

const printOpgavekompleksetComponent = (node, context) => {
  return /*#__PURE__*/jsx(PM2OpgavekompleksetComponent, {
    learningObjectId: node.pm2.learningObjectId,
    learningObjectTitle: node.pm2.learningObjectTitle,
    component: node.component,
    displayMode: node.options.displayMode,
    isScrambled: node.pm2.isScrambled,
    previewImage: node.meta.previewImage,
    indexOrLevel: node.meta.indexOrLevel,
    richtextDescription: printHtmlNodesToJsx(node.meta.richTextDescription),
    lightboxDescription: printHtmlNodesToText(node.meta.lightboxDescription ?? []),
    node: node
  }, generateJsxKey(context));
};
const opgavekompleksetComponentJsxPrinters = {
  "component-framework.opgavekomplekset": printOpgavekompleksetComponent
};

export { opgavekompleksetComponentJsxPrinters, printOpgavekompleksetComponent };
//# sourceMappingURL=printer.to-jsx.js.map
